import React, { useEffect, useRef, useState } from 'react';
import { Dialog, Heading, Modal, ModalOverlay } from 'react-aria-components';
import { MessageTextCircle02 } from '@untitledui/icons';
import { Button } from './untitled-ui/base/buttons/button';
import { TextArea } from './untitled-ui/base/textarea/textarea';
import { AnalyticsMemberRow, getPaymentReminderDraft, PaymentReminderDraft, sendPaymentReminder } from '../services/paymentAnalyticsService';

export default function PaymentReminderDialog({member,onClose,onSent}:{member:AnalyticsMemberRow['member'];onClose:()=>void;onSent:(message:string)=>void}) {
  const [draft,setDraft]=useState<PaymentReminderDraft|null>(null);
  const [message,setMessage]=useState('');
  const [error,setError]=useState('');
  const [sending,setSending]=useState(false);
  const [attempted,setAttempted]=useState(false);
  const locked=useRef(false);
  useEffect(()=>{
    let cancelled=false;
    getPaymentReminderDraft(member.id).then(value=>{if(!cancelled){setDraft(value);setMessage(value.message);}})
      .catch(e=>{if(!cancelled)setError(e instanceof Error?e.message:'Unable to prepare reminder');});
    return ()=>{cancelled=true;};
  },[member.id]);
  const send=async()=>{
    if(locked.current||!draft||!draft.enabled||!message.trim()||message.length>1000)return;
    locked.current=true;setSending(true);setError('');setAttempted(true);
    try {onSent(await sendPaymentReminder(member.id,message.trim(),draft.phone));onClose();}
    catch(e){setError(e instanceof Error?e.message:'Sending could not be confirmed. Check gateway history.');}
    finally{setSending(false);}
  };
  return <ModalOverlay isOpen isDismissable={!sending} isKeyboardDismissDisabled={sending} onOpenChange={open=>{if(!open&&!sending)onClose();}} className="payment-reminder-overlay">
    <Modal className="payment-reminder-modal"><Dialog className="payment-reminder-dialog">
      <MessageTextCircle02 className="payment-reminder-icon" aria-hidden="true"/>
      <Heading slot="title">Confirm payment reminder</Heading>
      <p>This sends a real SMS through the configured gateway. Review the recipient and edit the message before confirming.</p>
      <div className="payment-reminder-recipient"><strong>{member.fullName}</strong><span>{member.memberNumber}</span>{draft&&<span>SMS to {draft.phone}</span>}</div>
      {!draft&&!error&&<p role="status">Preparing reminder…</p>}
      {draft&&<><TextArea label="Reminder message" value={message} onChange={setMessage} rows={6} maxLength={1000} isDisabled={sending||attempted} isRequired/>
        <small>{message.length}/1000 characters · Longer or non-Latin messages may incur multiple SMS charges.</small>
        <Button size="sm" color="tertiary" isDisabled={sending||attempted} onPress={()=>setMessage(draft.message)}>Reset default message</Button>
        <p>Confirm actual renewal and payment records first. Analytics dates are estimates, not proof of an outstanding balance.</p>
        {!draft.enabled&&<p role="alert">SMS sending is disabled in this environment. No reminder can be sent.</p>}
      </>}
      {error&&<p role="alert" className="payment-reminder-error">{error}{attempted&&' No automatic retry was made. Verify gateway history before opening a new reminder.'}</p>}
      <footer><Button color="secondary" isDisabled={sending} onPress={onClose}>{attempted?'Close':'Cancel'}</Button><Button isLoading={sending} isDisabled={!draft||!draft.enabled||!message.trim()||message.length>1000||attempted} onPress={send}>Confirm & send SMS</Button></footer>
    </Dialog></Modal>
  </ModalOverlay>;
}
